import {Graph as BaseGraph} from '~/components'
import {date} from '@eitje/utils'
import {t} from '~/initializers/i18n'
import {useCustomApexOptions} from './use_custom_apex_options'
import {useQueryParams} from '~/hooks'
import {usePageContext} from '~/components'
import {DeltaPopoutContent} from './delta_popout_content'

export const Graph = () => {
	const {graphs: graphSeries, graphVariantsTaxonomy} = usePageContext()
	const {graph_name} = useQueryParams()

	const activeMetricName = graph_name || _.first(graphVariantsTaxonomy).name
	const activeSeries = graphSeries.find(series => series.name === activeMetricName)
	const {fullFormatFn, compactFormatFn} = graphVariantsTaxonomy.find(metric => metric.name === activeMetricName)

	const series = [{...activeSeries, graphName: activeMetricName, name: t(`dashboard.card.${activeMetricName}.title`)}]

	const customApexOptions = useCustomApexOptions()

	return (
		<BaseGraph
			series={series}
			formatY={compactFormatFn || fullFormatFn}
			popoutProps={{formatSeriesValue: fullFormatFn, ExtraContent: DeltaPopoutContent}}
			formatX={value => date(value).format("MMM [']YY")}
			apexOptions={customApexOptions}
			graphName={activeMetricName}
		/>
	)
}
